import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { ReactComponent as BackIcon } from 'images/back-arrow.svg'
import styled from 'styled-components'
import { SubheadEmphasized } from 'src/Styles/text-styles'
import { theme } from 'src/Styles/theme'

const BackBtnContainer = styled.a<{ isNative: boolean }>`
  display: ${({ isNative }) => (isNative ? 'none' : 'flex')};
  align-items: center;
  margin-bottom: 24px;
  cursor: pointer;
`
const BackBtnTitle = styled(SubheadEmphasized)`
  color: ${theme.colors.primary};
  padding-left: 8px;
`

const BackTitle = 'Back'

const BackButton = () => {
  const history = useHistory()
  const [isNativeApp, setNativeApp] = useState(false)

  useEffect(() => {
    const data = localStorage.getItem('isNativeApp')
    if (data || data === 'true') {
      setNativeApp(true)
    } else {
      setNativeApp(false)
    }
  }, [])

  const goBack = () => {
    history.goBack()
  }
  return (
    <BackBtnContainer onClick={goBack} isNative={isNativeApp}>
      <BackIcon width={16} height={16} />
      <BackBtnTitle>{BackTitle}</BackBtnTitle>
    </BackBtnContainer>
  )
}

export default BackButton
